import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import { cssClasses } from '@douyinfe/semi-foundation/lib/es/select/constants';
import BaseComponent from '../_base/baseComponent';
const prefixCls = cssClasses.PREFIX_GROUP;

class OptionGroup extends BaseComponent {
  render() {
    const {
      label,
      className,
      style
    } = this.props;
    const groupCls = cls(className, {
      [prefixCls]: true
    });

    if (!label && typeof label !== 'number') {
      return null;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: groupCls,
      style: style
    }, label);
  }

}

OptionGroup.isSelectOptionGroup = true;
OptionGroup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  label: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object
};
export default OptionGroup;